import { Component, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';

@Component({
    templateUrl: './capture-admin-missing-ndc-reports.component.html',
    imports: [ReportsComponent, NewReportOptionsTemplateDirective, ReportDetailsTemplateDirective]
})
export class CaptureAdminMissingNdcReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/missing_ndc_reports`;

  filtersForm = this.formBuilder.group({
    processedDate: [null],
  });
}
